import Decimal from 'decimal.js';

export class Helper {
  public static roundAwayFromZero(value: number, decimals: number): number {
    return new Decimal(value)
      .toDecimalPlaces(decimals, Decimal.ROUND_HALF_UP)
      .toNumber();
  }

  public static hbtValueGetter(params: any): string {
    
    if (params == null || params.data == null) return "";
    if (params.data.creditCategory == "Species") return "";
    if(params.data.hbt == 'Yes' || params.data.hbt == 'true') return 'Yes';
    if(params.data.hbt == 'No' || params.data.hbt == 'false' ) return 'No';
    return params.data.hbt ? "Yes" : "No";
  }
}